var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-switch",
        _vm._g(
          _vm._b(
            {
              attrs: { "active-value": 1, "inactive-value": 0 },
              model: {
                value: _vm.getValue,
                callback: function ($$v) {
                  _vm.getValue = $$v
                },
                expression: "getValue",
              },
            },
            "yxt-switch",
            _vm.$attrs.attrs,
            false
          ),
          _vm.$attrs.on
        )
      ),
      _c("span", { staticClass: "tlive-create__tip" }, [
        _vm._v(
          "\n     \n    " +
            _vm._s(
              _vm.$t(
                "pc_biz_externalConnectionWatchLive" /* 企业外部人员获得单独连接，通过微信授权观看 */
              )
            ) +
            "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }